module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/historico-asignaciones/historico-asignaciones.component.css
// module id = ./src/app/historico-asignaciones/historico-asignaciones.component.css
// module chunks = main